import React, { FC } from 'react'

import { FormControlLabel } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'

import { CustomCheckBox } from '../CustomCheckBox'

import { ControllableCheckboxProps } from './types'

export const ControllableCheckbox: FC<ControllableCheckboxProps> = ({ name, label }) => {
  const { control, watch } = useFormContext()
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <FormControlLabel
          control={<CustomCheckBox {...field} checked={watch(name)} />}
          label={label}
          sx={{ '& .MuiFormControlLabel-label': { fontWeight: 500 } }}
        />
      )}
    />
  )
}
